export default __webpack_public_path__ + "static/media/headerBackground.74ed188b.png";